import React from "react";

const BillsDetails = ({ onClose }) => {
  // Ensure onClose is a function and handle when modal is clicked outside
  const handleClose = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      onClick={handleClose} // Close modal when clicking outside the modal content
    >
      <div className="relative bg-white p-6 rounded-lg shadow-lg w-sm">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-3xl text-gray-600 hover:text-gray-800"
        >
          &times;
        </button>

        <h3 className="text-xl font-semibold mb-4">Billing Package Details</h3>

        <div className="flex">
          {/* Monthly Package Card */}
          <div className="bg-blue-100 p-6 rounded-lg shadow-md w-1/2">
            <h4 className="font-semibold text-lg mb-2">Monthly Package</h4>
            <h5 className="font-semibold text-sm mb-1">Per User Rate</h5>
            <p className="text-sm">Price per user: $5/month</p>
          </div>

          {/* Yearly Package Card */}
          {/* <div className="bg-green-100 p-6 rounded-lg shadow-md w-1/2">
            <h4 className="font-semibold text-lg mb-2">Yearly Package</h4>
            <h5 className="font-semibold text-sm mb-1">Per User Rate</h5>
            <p className="text-sm">Price per additional user: $50/year</p>
          </div> */}
        </div>

        {/* Additional Information Section */}
        <div className="mt-6">
          <h4 className="font-semibold text-lg mb-2">Additional Information</h4>
          <p className="text-sm mb-2">
            Both plans include 24/7 support, but the Yearly Package provides
            priority support with faster response times.
          </p>
          <p className="text-sm">
            You can upgrade or downgrade your plan anytime with no extra cost,
            ensuring flexibility for your needs.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BillsDetails;
